import React from "react";
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingHome from "../Components/LandingPage/LandingHome";
import InfoPage from "../Components/InfoPages/InfoPage";

export default function ApiRoutes() {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LandingHome />} />
                <Route path="/info/:slug" element={<InfoPage />} />
                <Route path="*" element={<LandingHome />} />
            </Routes>
        </Router>
    );
}
